import { useRef, useEffect } from 'react';

/**
 * usePrevious allows you to use the previous value (prevState)
 *
 * Taken from: https://reactjs.org/docs/hooks-faq.html#how-to-get-the-previous-props-or-state
 *
 * @param  {Any} value The value you need to know the previous value of
 * @return {Any}       The previous value
 */
function usePrevious(value: any): any {
  const ref = useRef();

  useEffect(() => {
    ref.current = value;
  });

  return ref.current;
}

export default usePrevious;
